export const emptyListing = {
  // BASIC
  type: "",
  subType: [],
  purpose: "",

  // BUILDING
  building: "",
  condition: "",
  renovation: "",
  rooms: "",
  bedrooms: null,
  floor: null,
  totalFloors: null,
  floors: null,
yardArea: null,
  notFirstFloor: false,
  notLastFloor: false,
  cadastralCode: "",
  openForForeign: false,
  phone: "",
isAgent: false,

 openForAgents: false,
priceNegotiable: false,
exchangePossible: false,
bankPayment: false,

// LOCATION (CRITICAL)
city: "",
district: "",
neighborhood: "",   // Tbilisi-style
localarea: "",      // Batumi / Kutaisi-style

// Street (MULTI-LANGUAGE SAFE)
street: {},          // { en: "Rustaveli", ka: "რუსთაველი" }
streetNumber: "",
manualStreet: false,

// Optional (for display_name from Nominatim)
fullAddress: {},     // { en: "...", ka: "..." }

// MAP
lat: null,
lng: null,
locationApproximate: true,


  // PRICE & SIZE
  price_gel: null,
  currency: "GEL",


  area: null,            // ← THIS is square meters, NOT location
  projectType: "",

  // EXTRAS
  amenities: [],
  photos: [],
  description: "",
};

